import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Cart = createSvgIcon(
  <path d="M0 2.25h2.25V16.5H.75v2.25h3.266A3.001 3.001 0 1 0 9 21c0-.896-.393-1.7-1.016-2.25h9.032A3.001 3.001 0 1 0 22 21c0-.896-.393-1.7-1.016-2.25H24V16.5H4.5V1.125C4.5.504 3.996 0 3.375 0H0v2.25Z" />,
  'Cart'
);

export { Cart };
